<template>
  <v-container grid-list-xl fluid class="pt-0">

    <v-layout row wrap>
      <v-flex md2>
        <simple-month-picker v-model="filter.month" label="Mes" :disabled="searched"></simple-month-picker>
      </v-flex>
      <v-flex md8 v-if='filter.month'>
        <v-select :disabled="searched" v-model="filter.employeeCompanyRut" :items="companies" item-text="employeeCompanyName" item-value="employeeCompanyRut" label="Empresa" hide-details></v-select>
      </v-flex>
      <v-flex md2 v-if='filter.employeeCompanyRut && companies.length > 0'>
        <v-btn color="primary" flat :disabled="searched" @click="getEmployees">Continuar</v-btn>
      </v-flex>
    </v-layout>

    <!-- panel1 -->
    <div v-if="panel1 && searched">


      <v-toolbar dark color="primary">
        <v-btn icon dark @click="searched = false; ">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex sm3>
            <v-text-field color="white" placeholder="xx.xxx.xxx-x" mask="##.###.###-N" v-on:keyup.enter="getEmployees" dark clearable hide-details label="Rut" v-model='filter.employeeRut'></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field color="white" placeholder="Nombre" v-on:keyup.enter="getEmployees" dark clearable hide-details label="Nombre" v-model='filter.employeeFullName'></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field color="white" placeholder="Cargo" v-on:keyup.enter="getEmployees" dark clearable hide-details label="Cargo" v-model='filter.employeeTitle'></v-text-field>
          </v-flex>
        </v-layout>
        <v-btn icon flat @click="getEmployees"><v-icon medium>search</v-icon></v-btn>
      </v-toolbar>


      <!-- table -->
      <v-data-table :headers="headers" :items="items" :loading="loadingItems" class="elevation-1" rows-per-page-text='Mostrar' :rows-per-page-items="[10, 50]">
        <template v-slot:items="props">
          <td>{{ props.item.rut_formated }}</td>
          <td>{{ props.item.full_name }}</td>
          <td>{{ props.item.employeeTitle }}</td>
          <td>{{ props.item.count_records }}</td>
          <td>
            <v-btn color="primary" icon @click="openPersonalRecords(props.item.employeeRut, props.item.employeeCompanyRut, filter.month)">
              <v-icon>fas fa-clipboard-list</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:footer>
          <td :colspan="4">
            <strong>{{items.length}} personas con registros.</strong>
          </td>
        </template>
      </v-data-table>
      <!-- ./table -->
    </div>
    <!-- ./panel1 -->

    <div v-if="!panel1">
      <personal-records :selectedEmployee="selectedEmployee" @close="closePersonalRecords"></personal-records>
    </div>

  </v-container>
</template>


<script>

import moment from 'moment'
import axios from 'axios';
import SimpleMonthPicker from '@/components/app/monthPicker';
import PersonalRecords from '@/views/app/attendance/personalRecords';

export default {
  components: {
    SimpleMonthPicker,
    PersonalRecords
  },
  data: () => ({
    searched : false,
    filter : {
      month: moment().format('YYYY-MM')
    },
    items : [],
    loadingItems:false,
    headers: [
      { text: 'Rut', value: 'employeeRut' },
      { text: 'Nombre', value: 'full_name' },
      { text: 'Cargo', value: 'employeeTitle' },
      { text: 'Registros', value: 'count_records' },
    ],
    companies : [],
    panel1: true,
    selectedEmployee : {
      month : null,
      employeeRut : null,
      employeeCompanyRut : null,
    }
  }),
  watch: {
    'filter.month' : function(val){
      if(val){
        this.getCompanies();
      }else{
        this.companies = [];
        this.filter = {};
        this.items = [];
      }
    }
  },
  created(){
    // let today = new Date();
    // this.filter.month = moment(today).format('YYYY-MM')
    // console.log(moment(today).format('YYYY-MM-DD'));
  },
  mounted () {
    axios.defaults.headers.post['Accept'] = 'application/json';
    axios.defaults.baseURL = localStorage.getItem('ipApiServer');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

    if(this.filter.month){
      this.getCompanies();
    }
    // this.getCompanies();
  },
  methods: {
    getCompanies () {
      let $this = this;
      let params = Object.assign(this.filter);
      axios.get( 'admin/getCompanies', { params : params } )
           .then( function(response){
             $this.companies = response.data;
             $this.filter.employeeCompanyRut = localStorage.getItem('defaultCompanyRut');
           })
           .catch(error => {
             if(error.response.status == 422){
               window.getApp.$emit('APP_BAD_REQUEST', error.response.data.message);
             }
           });
    },
    getEmployees () {
      let $this = this;
      let params = Object.assign(this.filter);
      $this.loadingItems = true;
      axios.get( 'admin/getEmployees', { params : params } )
           .then( function(response){
             $this.items = response.data;
             $this.loadingItems = false;
             $this.searched = true;
             // // $this.companies = response.data;
           })
           .catch(error => {
             if(error.response.status == 422){
               window.getApp.$emit('APP_BAD_REQUEST', error.response.data.message);
             }
           });
    },
    openPersonalRecords(employeeRut, employeeCompanyRut, month){
      this.selectedEmployee = {
        employeeRut : employeeRut,
        employeeCompanyRut : employeeCompanyRut,
        month : month
      };
      this.panel1 = false;
    },
    closePersonalRecords(){
      this.panel1 = true;
    }
  }

};

</script>
